import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { environment } from 'environments/environment';
import { Item, ItemSearchFilter } from 'app/shared/models/orders-and-billing';
import { OrderApiConfiguration } from '../order-and-billing';
import { map } from 'rxjs/operators';
import { PagedResults } from 'app/shared/interfaces/paged-results.interface';

@Injectable()
export class VaccinesService {

    private _bySearchUrl: string;
    private actionUrl: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration
    ) {
        this.actionUrl = _configuration.server;

        this._bySearchUrl = this.actionUrl + _configuration.item.parentsAndLeaf;

    }
    private _buildSearchQueryString(itemSearchFilter: ItemSearchFilter): string {
        const params: string[] = [];

        if (itemSearchFilter.Code) {
            params.push(`Code=${encodeURIComponent(itemSearchFilter.Code)}`);
        }

        if (itemSearchFilter.TypeId !== undefined && itemSearchFilter.TypeId !== null) {
            params.push(`TypeId=${itemSearchFilter.TypeId}`);
        }

        if (itemSearchFilter.Description) {
            params.push(`Description=${encodeURIComponent(itemSearchFilter.Description)}`);
        }

        if (itemSearchFilter.IsActive !== undefined && itemSearchFilter.IsActive !== null) {
            params.push(`IsActive=${itemSearchFilter.IsActive}`);
        }

        return params.join("&");
    }



    getItemIdByCode(code: string): Observable<number | null> {
        return this._http.get<any[]>(`${this._bySearchUrl}`, {
            params: { Code: code, PageSize: '1' }
        }).pipe(
            map(items => items && items.length > 0 ? items[0].Id : null)
        );
    }
    getPaged(page: number, rows: number): Observable<PagedResults<any>> {
        return this._http.get<PagedResults<any>>(
            `${environment.queryModel}VaccineDetails/paged?page=${page}&rows=${rows}`
        );
    }

    getFilteredVaccines(filter: any): Observable<any[]> {
        return this._http.get<any[]>(`${this._bySearchUrl}?${this._buildSearchQueryString(filter)}`);
    }

    add = (data: any): Observable<any> => {
        return this._http.post<any>(`${environment.core}Vaccine`, data);
    }


    update = (data: any): Observable<any> => {
        return this._http.put<any>(`${environment.core}Vaccine`, data);
    }

    delete = (id: number): Observable<any> => {
        return this._http.delete<any>(`${environment.queryModel}VaccineDetails?id=${id}`);
    }

}
